import { guideSteps, trustItems } from "@/mocks/homeContent";

function GuideTrust() {
  return (
    <section id="guide" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-8">
          {/* guide */}
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-compass-3-fill"></i>
              换新防走失指南
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              记住这四步，换新地址也走不丢
            </h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              域名迁移最怕的不是变化，而是失联。用一套固定的习惯，让每次换新地址都第一时间跟上。
            </p>

            <ol className="mt-7 space-y-4">
              {guideSteps.map((step) => (
                <li
                  key={step.no}
                  className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                    <i className={`${step.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      <span className="mr-1.5 text-primary-600">{step.no}</span>
                      {step.title}
                    </h3>
                    <p className="mt-1 text-sm leading-6 text-foreground-600">{step.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* trust panel */}
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-shield-star-line"></i>
              为什么可信
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              全程登记，透明可回溯
            </h2>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              本页以档案维护的标准同步每一次换新地址，杜绝信息真空，让访客在域名迁移期间始终有据可依。
            </p>

            <div className="mt-6 grid grid-cols-2 gap-4">
              {trustItems.map((t) => (
                <div
                  key={t.label}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5 text-center"
                >
                  <p className="font-heading text-3xl font-bold text-primary-600 md:text-4xl">
                    {t.value}
                  </p>
                  <p className="mt-2 text-xs font-medium text-foreground-600 md:text-sm">
                    {t.label}
                  </p>
                </div>
              ))}
            </div>

            {/* mini trust cards */}
            <div className="mt-4 space-y-4">
              <div className="flex items-start gap-3 rounded-2xl bg-accent-50 p-4 ring-1 ring-accent-200">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                  <i className="ri-time-line text-lg"></i>
                </span>
                <p className="text-sm leading-6 text-foreground-700">
                  <span className="font-semibold text-foreground-900">最快 24 小时同步：</span>
                  域名迁移完成后，发布历史、旧网址状态与当前入口会在本页集中更新。
                </p>
              </div>
              <div className="flex items-start gap-3 rounded-2xl bg-secondary-50 p-4 ring-1 ring-secondary-200">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-secondary-500 text-background-50">
                  <i className="ri-verified-badge-fill text-lg"></i>
                </span>
                <p className="text-sm leading-6 text-foreground-700">
                  <span className="font-semibold text-foreground-900">唯一官方对照源：</span>
                  当前入口、换新地址均以此页公布为准，防止旧网址仿冒与误导。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GuideTrust;